import { DocumentGedDto } from "../dto/GenApi.iNotPaie.Dto/DocumentGedDto";
import { DossierGedDto } from "../dto/GenApi.iNotPaie.Dto/DossierGedDto";

/**
 * DossierGedDto avec des propriétés supplémentaires pour la vue
 */
export interface DossierGedViewModel extends DossierGedDto {
    isOpen: boolean;
    isLoading: boolean;
    isSelected: boolean;
    dossierParent?: DossierGedViewModel;
    Documents: DocumentGedViewModel[];
    SousDossier: DossierGedViewModel[];
}

/**
 * DocumentGedDto avec des propriétés supplémentaires pour la vue
 */
export interface DocumentGedViewModel extends DocumentGedDto {
    isSelected: boolean;
    dossierParent?: DossierGedViewModel;
}

export default class DocumentGedHelper {
    /**
     * Transforme un DossierGedDto en DossierGedViewModel
     * @param dossier
     * @returns
     */
    static mapDossierToViewModel(dossier: DossierGedDto): DossierGedViewModel {
        return {
            ...dossier,
            SousDossier: dossier.SousDossier ? dossier.SousDossier.map(sousDossier => this.mapDossierToViewModel(sousDossier)) : [],
            isOpen: false,
            isLoading: false,
            isSelected: false,
            dossierParent: undefined,
            Documents: dossier.Documents ? dossier.Documents.map(doc => this.mapDocumentToViewModel(doc)) : []
        };
    }

    /**
     * Transforme un DocumentGedDto en DocumentGedViewModel
     * @param document
     * @returns
     */
    static mapDocumentToViewModel(document: DocumentGedDto): DocumentGedViewModel {
        return {
            ...document,
            isSelected: false,
            dossierParent: undefined
        }
    }

    /**
     * Traverse l'arborescence de dossiers/documents, afin de trier les documents par date, de la plus ancienne à la plus récente
     * @param {DossierGedDto} niveau
     * @returns {DossierGedDto} L'arborescence avec fichiers triés
     */
    static sortArborescence(niveau: DossierGedDto): DossierGedDto {

        niveau.SousDossier.forEach(sd => {
            this.sortArborescence(sd);
        });

        niveau.Documents = this.sortDocuments(niveau.Documents);

        return niveau;
    }

    /**
     * Prends une liste de DocumentsGedDto en paramètres et la trie selon la date, par ordre croissant
     * @param {DocumentGedDto[]} documents
     * @returns {DocumentGedDto[]} La liste triée selon la date
     */
    static sortDocuments(documents: DocumentGedDto[]): DocumentGedDto[] {

        // on trie la liste par date de création, de la plus ancienne à la plus récente
        documents.sort((a, b) => {

            // ce bloc est nécessaire puisque le navigateur considère DateDeModification comme une string et pas une date
            const date1 = new Date(a.DateDeModification.toString());
            const date2 = new Date(b.DateDeModification.toString());

            // on obtient la date ne contenant que l'année, le mois et le jour
            const finalDate1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
            const finalDate2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());

            // on retourne le résultat du tri
            return finalDate1.getTime() - finalDate2.getTime();
        });

        return documents;
    }
}



// WEBPACK FOOTER //
// ./src/Helper/DocumentGedHelper.ts